import { Perk } from "../Types/Perk";
import "../css/perks.css";

type PerkProps = {
  perk: Perk;
  value: number;
  onValueChange: (val: number) => void;
};

function PerkComponent({ perk, value, onValueChange }: PerkProps) {
  const inputId = `perk-value-${perk.name.replace(/\s+/g, "-")}`;
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = Number(e.target.value);
    const safe = Number.isFinite(raw) ? Math.max(0, raw) : 0;
    onValueChange(safe);
  };
  return (
    <div className="perkDiv">
      <label htmlFor={inputId}>{perk.name}</label>
      <div className="valueDiv">
        <span className="dollarSpan" aria-hidden="true">$</span>
        <input
          id={inputId}
          type="number"
          className="dollarInput"
          min={0}
          step={25}
          value={value}
          onChange={handleChange}
          aria-label={`Value for ${perk.name} in dollars`}
        />
      </div>
    </div>
  );
}

export default PerkComponent;